import Direction from './direction.js';



class FilledAmountGetter {
    constructor(direction) {
        this.width = null;
        this.height = null;

        this._direction = direction;

        this._filledStart = [];
        this._filledEnd = [];
    }

    calculate(mask, regionDistanceLayers, emptyId) {
        const { width, height } = mask;
        const getAtPos = mask.makeGetterAtPos(), getAtXY = mask.makeGetterAtXY();
        const horizontal = this._direction === Direction.HORIZONTAL;

        this.width = width;
        this.height = height;

        const lineCount = horizontal ? height : width;
        const lineLength = horizontal ? width : height;

        this._filledStart.length = lineCount;
        this._filledEnd.length = lineCount;
        for (let lineNum = 0; lineNum < lineCount; lineNum++) {
            this._filledStart[lineNum] = [];
            this._filledEnd[lineNum] = [];
        }

        let emptyRegionData = regionDistanceLayers.regionData.get(emptyId);
        if (emptyRegionData) {
            let layer = emptyRegionData.layers[0];

            if (horizontal) {
                const lineEnd = width-1;

                for (let lineNum = 0; lineNum < lineCount; lineNum++) {
                    if (getAtXY(0, lineNum) !== emptyId) {
                        this._filledStart[lineNum].push(0);
                    }

                    if (getAtXY(lineEnd, lineNum) !== emptyId) {
                        this._filledEnd[lineNum].push(width);
                    }
                }

                for (let pos of layer) {
                    const posInLine = pos%width, lineNum = Math.floor(pos/width);

                    if (posInLine !== 0 && getAtPos(pos-1) !== emptyId) {
                        this._filledEnd[lineNum].push(posInLine);
                    }

                    if (posInLine !== lineEnd && getAtPos(pos+1) !== emptyId) {
                        this._filledStart[lineNum].push(posInLine+1);
                    }
                }
            } else {
                const lineEnd = height-1;

                for (let lineNum = 0; lineNum < lineCount; lineNum++) {
                    if (getAtXY(lineNum, 0) !== emptyId) {
                        this._filledStart[lineNum].push(0);
                    }

                    if (getAtXY(lineNum, lineEnd) !== emptyId) {
                        this._filledEnd[lineNum].push(height);
                    }
                }

                for (let pos of layer) {
                    const lineNum = pos%width, posInLine = Math.floor(pos/width);

                    if (posInLine !== 0 && getAtPos(pos-width) !== emptyId) {
                        this._filledEnd[lineNum].push(posInLine);
                    }

                    if (posInLine !== lineEnd && getAtPos(pos+width) !== emptyId) {
                        this._filledStart[lineNum].push(posInLine+1);
                    }
                }
            }
        }

        for (let lineNum = 0; lineNum < lineCount; lineNum++) {
            this._filledStart[lineNum].sort((x1, x2) => x1-x2);
            this._filledEnd[lineNum].sort((x1, x2) => x1-x2);
        }
    }

    getFilledAmount(lineNum, pos0, pos1) {
        const filledStart = this._filledStart[lineNum], filledEnd = this._filledEnd[lineNum];

        let filledAmount = 0;

        for (let i = 0; i < filledAmount.length; i++) {
            let startPos = filledStart[i], endPos = filledEnd[i];

            let clampPos0 = Math.min(Math.max(startPos, pos0), endPos);
            let clampPos1 = Math.min(Math.max(startPos, pos1), endPos);

            filledAmount += clampPos1-clamPos0;
        }

        return filledAmount;
    }

    getEmptyAmount(lineNum, pos0, pos1) {
        const filledAmount = this.getFilledAmount(lineNum, pos0, pos1);
        return (pos1-pos0)-filledAmount;
    }

    getEmptyLengthAtEdge(lineNum, farEdge) {
        const horizontal = this._direction === Direction.HORIZONTAL;
        const lineLength = horizontal ? this.width : this.height;

        if (farEdge) {
            const filledEnd = this._filledEnd[lineNum];

            if (filledEnd.length === 0) {
                return lineLength;
            } else {
                return lineLength-filledEnd[filledEnd.length-1];
            }
        } else {
            const filledStart = this._filledStart[lineNum];

            if (filledStart.length === 0) {
                return lineLength;
            } else {
                return filledStart[0];
            }
        }
    }
}

export default FilledAmountGetter;
